import React, { useState } from "react";
import { shortenEmail } from "../../cf";
import Image from "../Tags/Image";
import { useStoreIntegrations } from "../../stores/useStoreIntegrations";

export default function CrmContacts({ crmPhonesEmails, spaceClasses = "border-b pb-4" }) {
  const { activeCRMIntegration } = useStoreIntegrations();
  const [isCopied, setIsCopied] = useState(false);
  const [showCopy, setShowCopy] = useState(false);
  const copyText = (event, data) => {
    event.stopPropagation();
    event.preventDefault();
    let input = document.createElement("input");
    input.setAttribute("value", data);
    document.body.appendChild(input);
    input.select();
    let result = document.execCommand("copy");
    document.body.removeChild(input);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);

    return result;
  };

  const handleShowCopy = (mouseleave) => {
    if (mouseleave) {
      setShowCopy(false);
    } else {
      setShowCopy(true);
    }
  };
  return (
    <>
      {(crmPhonesEmails?.phone_numbers?.length > 0 || crmPhonesEmails?.email_addresses?.length > 0) && (
        <div
          className={`space-y-2 ${
            crmPhonesEmails.phone_numbers?.length > 0 || crmPhonesEmails.email_addresses?.length > 0
              ? spaceClasses
              : ""
          }`}
        >
          {crmPhonesEmails.phone_numbers?.length > 0 &&
            crmPhonesEmails.phone_numbers.map((number, index) => (
              <span key={index} className="text-[12px] flex items-center w-full">
                <span className="inline-flex w-9 text-center">
                  <Image
                    src={`/images/crm/${activeCRMIntegration?.integration?.key}.svg`}
                    className="h-4 no-invert"
                    alt="Phone"
                  />
                </span>
                <span className="relative flex-1 ml-2">
                  <span
                    className="cursor-pointer text-[14px] text-brand-700 font-semibold custom__tooltip__parent"
                    onClick={(e) => copyText(e, number)}
                  >
                    {number}
                    <span className="absolute  -top-8 left-10 w-[90px] custom__tooltip">
                      {" "}
                      {isCopied ? "Copied" : "Click to copy"}
                    </span>
                  </span>
                </span>
              </span>
            ))}

          {crmPhonesEmails.email_addresses?.length > 0 &&
            crmPhonesEmails.email_addresses.map((email, index) => (
              <span key={index} className="text-[12px] flex items-center w-full">
                <span className="inline-flex w-9 text-center">
                  <Image
                    src={`/images/crm/${activeCRMIntegration?.integration?.key}.svg`}
                    alt="Email"
                    className="h-4 no-invert"
                  />
                </span>
                <span className="relative flex-1 ml-2">
                  <span
                    className="cursor-pointer text-[14px] text-brand-700 font-semibold custom__tooltip__parent"
                    onClick={(e) => copyText(e, email)}
                  >
                    {shortenEmail(email)}
                    <span className="absolute  -top-8 left-10 w-[90px] custom__tooltip">
                      {" "}
                      {isCopied ? "Copied" : "Click to copy"}
                    </span>
                  </span>
                </span>
              </span>
            ))}
        </div>
      )}
    </>
  );
}
